export default {"src":"/_next/static/media/better-stack-small.c1819945.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};